<ng-template #modal>
  <div class="container my-2">
    <div class="row mb-3">
      <bdg-label type="headline">
        Conforme as exigências da Lei Geral de Proteção de Dados (LGPD) em relação ao tratamento de dados pessoais:
      </bdg-label>
    </div>
    <div class="row mb-3">
      Os seus dados estão sendo coletados para a execução de políticas públicas a que se refere o SIGRESIDÊNCIAS.
    </div>
    <div class="row mb-3">
      <ul>
        <li>
          <bdg-label type="body-1">
            O objetivo da coleta dos seus dados é apenas para o cumprimento das finalidades específicas de obtenção de
            informações que viabilizem o pagamento de bolsas aos residentes, bem como no gerenciamento e monitoramento
            dos programas de residência.
          </bdg-label>
        </li>
        <li>
          <bdg-label type="body-1">
            Os seus dados ficarão armazenados no nosso sistema para que continuemos executando políticas públicas em
            saúde.
          </bdg-label>
        </li>
        <li>
          <bdg-label type="body-1">
            Os seus dados serão compartilhados com o Ministério da Saúde e, quando necessário, com as instituições
            bancárias para o pagamento das bolsas.
          </bdg-label>
        </li>
      </ul>
    </div>
    <div class="row mb-3">
      <bdg-label type="body-1"> Para saber mais, consulte os nossos Termos de Uso e Política de Privacidade </bdg-label>
      <bdg-label type="body-1">
        Caso haja dúvida, entre em contato através do e-mail:
        <a href="mailto:residencias@saude.gov.br">residencias@saude.gov.br</a>!
      </bdg-label>
    </div>
    <div class="row mt-5">
      <div class="d-flex col-sm-6 justify-content-start">
        <a href="/termos" target="_blank" style="text-decoration: underline">
          <bdg-label type="subheading-2"> Visualizar termos de uso </bdg-label>
        </a>
      </div>
      <div class="d-flex col-sm-6 justify-content-end">
        <bdg-button matStyle="raised" color="primary" label="ESTOU CIENTE DOS TERMOS" (click)="onSubmit()">
        </bdg-button>
      </div>
    </div>
  </div>
</ng-template>
